import { isParamTrue } from './url';


function formatTime(time) {
  const date = new Date(time);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

let didDefer;

export function installDebugPanel() {
  if (!isParamTrue('bambuserVodDiscover')) return;

  if (!didDefer) {
    didDefer = true;
    if ('requestIdleCallback' in window) {
      // Defer loading the player until the browser is idle
      window.requestIdleCallback(() => {
        setup();
      }, {
        timeout: 5000, // Don't wait more than 5 seconds
      });
    } else if (document.readyState === 'loading') {
      // Defer until the DOM is ready
      setup();
    }
  }
}

function setup() {
  const debugPanel = document.createElement('div');
  debugPanel.style.position = 'fixed';
  debugPanel.style.top = '20px';
  debugPanel.style.right = '20px';
  debugPanel.style.zIndex = 2147483647;
  debugPanel.id = '__bambuser-debug-panel__';
  debugPanel.innerHTML = `
    <div>
      <div class="__bambuser-debug-panel__title">
        <h1>Bambuser Debug Panel</h1>
      </div>
      <div id="__bambuser-debug-panel__instances">
      </div>
    </div>
  `;
  document.body.appendChild(debugPanel);

  const styleElem = document.createElement('style');
  styleElem.setAttribute('type', 'text/css');
  const styles = `
    #__bambuser-debug-panel__, #__bambuser-debug-panel__ * {
      all: revert;
    }
    #__bambuser-debug-panel__ {
      padding: 4px;
      border-radius: 6px;
      box-shadow: 0 0 10px rgba(0,0,0,0.5);
      overflow: auto;
      border: 2px solid #000;
      width: 340px;
    }
    #__bambuser-debug-panel__, #__bambuser-debug-panel__ * {
      font-family: monospace;
      color: #000;
      background-color: #fff;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__title h1 {
      font-size: 16px;
      user-select: none;
      cursor: move;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance {
      border: 2px solid #666;
      padding: 4px;
      margin-bottom: 4px;
      border-radius: 3px;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance.__bambuser-debug-panel__instance_error {
      border: 2px solid red;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_title {
      /*margin-bottom: 8px;*/
      cursor: pointer;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_title h2 {
      font-size: 12px;
      margin: 0;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_title h3 {
      font-size: 10px;
      margin: 0;
      color: #666;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_metadata {
      font-size: 10px;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_actions {
      margin-top: 8px;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_video_empty {
      color: darkorange;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_content {
      display: none;
      margin-top: 8px;
      gap: 8px;
      flex-direction: column;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_content button {
      width: max-content;
      cursor: pointer;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_message_header {
      cursor: pointer;
    }
    #__bambuser-debug-panel__ .__bambuser-debug-panel__instance_message_contents {
      display: none;
      color: #666;
      font-size: 10;
      white-space: pre-wrap;
    }
    @keyframes __bambuser-debug-panel__highlight {
      0%, 100% {
        opacity: 1;
      }
      50% {
        opacity: 0.2;
      }
    }
    .__bambuser-debug-panel__highlight {
      outline: 10px solid red;
      background-color: rgba(255, 0, 0, 0.2);
      outline-offset: 1px;
      animation: __bambuser-debug-panel__highlight 1s infinite;
    }
  `;
  'textContent' in styleElem
    ? (styleElem.textContent = styles)
    : (styleElem.styleSheet.cssText = styles);
  document.head.appendChild(styleElem);

  const instances = {};

  const addMessage = (message) => {
    if (message.eventType === 'create') {
      instances[message.debugId] = message.data;
      const instancesDiv = document.getElementById('__bambuser-debug-panel__instances');
      const instanceDiv = document.createElement('div');
      const instanceTitle = (() => {
        if (message.data.type === 'bam-playlist') {
          return {
            title: message.data.attributes.containerId,
            subtitle: 'Shoppable Video',
          };
        }
        return {
          title: message.data.type || 'Bambuser Instance'
        };
      })();

      instanceDiv.innerHTML = `
        <div class="__bambuser-debug-panel__instance_title">
          ${instanceTitle.subtitle ? `<h3>${instanceTitle.subtitle}</h3>` : ''}
          <h2>${instanceTitle.title}</h2>
          <div class="__bambuser-debug-panel__instance_metadata"></div>
          <div class="__bambuser-debug-panel__instance_actions">
            <button class="__bambuser-debug-panel__instance_btn_locate">Locate on page</button>
            <button class="__bambuser-debug-panel__instance_btn_manage" disabled>Manage</button>
            <button class="__bambuser-debug-panel__instance_btn_show_events">Show logs</button>
          </div>
        </div>
        <div class="__bambuser-debug-panel__instance_content">
          <div class="__bambuser-debug-panel__instance_messages">
          </div>
        </div>
      `;
      instanceDiv.setAttribute('id', `__bambuser-debug-panel_instance_${message.debugId}`);
      instanceDiv.classList.add('__bambuser-debug-panel__instance');
      const locateBtnElem = instanceDiv.querySelector('.__bambuser-debug-panel__instance_btn_locate');
      locateBtnElem.addEventListener('click', () => {
        locateBtnElem.disabled = true;
        const elementShadowRoot = message.data.element.shadow;
        const addedElems = [];
        if (elementShadowRoot.querySelectorAll('*').length === 0) {
          const emptyStyleHelper = document.createElement('style');
          emptyStyleHelper.setAttribute('type', 'text/css');
          const styles = `
            :host {
              display: block;
            }
            .wrapper {
              width: 100%;
              height: 60px;
            }
          `;
          'textContent' in emptyStyleHelper
            ? (emptyStyleHelper.textContent = styles)
            : (emptyStyleHelper.styleSheet.cssText = styles);
          elementShadowRoot.appendChild(emptyStyleHelper);
          addedElems.push(emptyStyleHelper);
          const wrapper = document.createElement('div');
          wrapper.classList.add('wrapper');
          wrapper.innerText = 'Empty playlist';
          elementShadowRoot.appendChild(wrapper);
          addedElems.push(wrapper);
        }
        message.data.element.scrollIntoView();
        message.data.element.classList.add('__bambuser-debug-panel__highlight');
        window.setTimeout(() => {
          message.data.element.classList.remove('__bambuser-debug-panel__highlight');
          for (const addedElem of addedElems) {
            addedElem.parentNode.removeChild(addedElem);
          }
          locateBtnElem.disabled = false;
        }, 2000);
      });
      const manageBtnElem = instanceDiv.querySelector('.__bambuser-debug-panel__instance_btn_manage');
      manageBtnElem.addEventListener('click', () => {
        const metadata = instances[message.debugId].metadata;
        const orgId = message.data.attributes.orgId;
        const pageId = metadata.distributionPageId;
        const playlistId = metadata.distributionContainerId;
        window.open(`${process.env.HOSTING_DASHBOARDURL}/${orgId}/on-demand/pages/${pageId}/playlists/${playlistId}`, '_blank');
      });
      const showEventsBtnElem = instanceDiv.querySelector('.__bambuser-debug-panel__instance_btn_show_events');
      showEventsBtnElem.addEventListener('click', () => {
        const elem = instanceDiv.querySelector(`.__bambuser-debug-panel__instance_content`);
        elem.style.display = elem.style.display === 'flex' ? 'none' : 'flex';
      });
      instancesDiv.appendChild(instanceDiv);
      renderMessage({
        ...message,
        data: {
          attributes: message.data.attributes,
        },
      });
    } else if (message.eventType === 'error' || message.eventType === 'info') {
      renderMessage(message);
      if (message.eventType === 'error') {
        const instanceDiv = document.querySelector(`#__bambuser-debug-panel__instances #__bambuser-debug-panel_instance_${message.debugId}`);
        instanceDiv.classList.add('__bambuser-debug-panel__instance_error');
      }

    } else if (message.eventType === 'bam-playlist:loaded' || message.eventType === 'bam-playlist:setupComplete') {
      renderMessage(message);
      if (message.eventType === 'bam-playlist:loaded') {
        instances[message.debugId].metadata = message.data;
        const instanceDiv = document.querySelector(`#__bambuser-debug-panel__instances #__bambuser-debug-panel_instance_${message.debugId}`);
        const metadataElem = instanceDiv.querySelector(` .__bambuser-debug-panel__instance_metadata`);
        metadataElem.innerHTML = `
          <div class="__bambuser-debug-panel__instance_videos ${!message.data.playlist.length ? '__bambuser-debug-panel__instance_video_empty' : ''}">Videos: ${message.data.playlist.length}${message.data.nextCursor ? '+' : ''}</div>
        `;
        instanceDiv.querySelector('.__bambuser-debug-panel__instance_btn_manage').disabled = false;
      }
    } else {
      console.log('Unknown message', message);
    }

    // Drag with mouse
    let isDragging = false;
    let offsetX, offsetY;

    debugPanel.querySelector('.__bambuser-debug-panel__title').addEventListener('mousedown', (e) => {
      isDragging = true;
      offsetX = e.clientX - debugPanel.getBoundingClientRect().left;
      offsetY = e.clientY - debugPanel.getBoundingClientRect().top;
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    function onMouseMove(e) {
      if (isDragging) {
        debugPanel.style.left = `${e.clientX - offsetX}px`;
        debugPanel.style.top = `${e.clientY - offsetY}px`;
      }
    }

    function onMouseUp() {
      isDragging = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }
  };

  const renderMessage = (message) => {
    const instancesDiv = document.getElementById('__bambuser-debug-panel__instances');
    const messageDiv = document.createElement('div');
    messageDiv.innerHTML = `
      <div class="__bambuser-debug-panel__instance_message">
        <div class="__bambuser-debug-panel__instance_message_header">${formatTime(message.time)} ${message.eventType}</div>
        <div class="__bambuser-debug-panel__instance_message_contents">${JSON.stringify(message.data, null, 2)}</div>
      </div>
    `;
    messageDiv.querySelector('.__bambuser-debug-panel__instance_message_header').addEventListener('click', () => {
      const elem = messageDiv.querySelector('.__bambuser-debug-panel__instance_message_contents');
      elem.style.display = elem.style.display === 'block' ? 'none' : 'block';
    });
    instancesDiv.querySelector(`#__bambuser-debug-panel_instance_${message.debugId} .__bambuser-debug-panel__instance_messages`).appendChild(messageDiv);
  };

  const existingMessages = window.__bambuserDebugMessages || [];
  window.__bambuserDebugMessages = {
    push: addMessage,
  };
  for (const message of existingMessages) {
    addMessage(message);
  }
};